import type { ReactNode } from "react";
import { AvtaleSectionWithHeader } from "../common/AvtaleSectionWithHeader";

export const BekreftelseSection = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode[] | ReactNode;
}) => {
  return (
    <AvtaleSectionWithHeader title={title}>{children}</AvtaleSectionWithHeader>
  );
};
